import store from './store';
import { setOnlineStatus, setOutboxCount } from './store/slices/offlineSlice';
import { db } from './indexedDB';

const SW_URL = `${process.env.PUBLIC_URL}/service-worker.js`;

function updateBadge(count) {
    if (!('setAppBadge' in navigator)) return;
    if (count > 0) {
        navigator.setAppBadge(count);
    } else {
        navigator.clearAppBadge();
    }
}

async function getPendingCount() {
    const [outbox, actionQueue] = await Promise.all([
        db.outbox.count(),
        db.action_queue.count(),
    ]);
    return outbox + actionQueue;
}

export function register() {
    if (!('serviceWorker' in navigator)) return;

    // Unregister any stale SW that isn't our current one (e.g. old serviceworker.js)
    navigator.serviceWorker.getRegistrations().then((registrations) => {
        for (const reg of registrations) {
            const swUrl = reg.active?.scriptURL || reg.installing?.scriptURL || reg.waiting?.scriptURL || '';
            if (swUrl && !swUrl.endsWith('service-worker.js')) {
                reg.unregister();
                console.log('🧹 Unregistered stale SW:', swUrl);
            }
        }
    });

    window.addEventListener('load', () => {
        navigator.serviceWorker
            .register(SW_URL)
            .then((registration) => {
                console.log('✅ Service worker registered:', registration.scope);

                registration.onupdatefound = () => {
                    const installing = registration.installing;
                    if (!installing) return;

                    installing.onstatechange = () => {
                        if (installing.state === 'installed' && navigator.serviceWorker.controller) {
                            installing.postMessage({ type: 'SKIP_WAITING' });
                        }
                    };
                };
            })
            .catch((err) => console.error('❌ Service worker registration failed:', err));

        // Listen for outbox updates posted by the SW
        navigator.serviceWorker.addEventListener('message', (event) => {
            if (event.data?.type === 'OUTBOX_UPDATED') {
                getPendingCount().then((count) => {
                    store.dispatch(setOutboxCount(count));
                    updateBadge(count);
                });
            }
        });
    });

    // Sync count and badge on startup
    getPendingCount().then((count) => {
        store.dispatch(setOutboxCount(count));
        updateBadge(count);
    });

    window.addEventListener('online', () => store.dispatch(setOnlineStatus(true)));
    window.addEventListener('offline', () => store.dispatch(setOnlineStatus(false)));
}

export function unregister() {
    if ('serviceWorker' in navigator) {
        navigator.serviceWorker.ready
            .then((registration) => registration.unregister())
            .catch((err) => console.error('❌ Service worker unregister failed:', err));
    }
}
